(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.bh-header');
  if (!header) return;

  var toggle = header.querySelector('.bh-header-toggle');
  var drawer = header.querySelector('.bh-mobile-drawer');

  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      drawer.classList.toggle('is-open');
      document.body.classList.toggle('bh-mobile-open');
    });
  }

  header.querySelectorAll('.bh-mobile-item--parent .bh-mobile-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var parent = btn.closest('.bh-mobile-item');
      parent.classList.toggle('is-open');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
